import Board from '../../components/board/board';
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';
import CookiesBanner from '../../components/legals/cookiesBanner';
import useNextRouterHook from '../../hooks/useNextRouterHook';
import useGetStartupUrl from '../../hooks/useGetStartupsUrl';
import NextHead from '../../components/header/nextHead';

export default function BoardPage() {
  const routerTo = useNextRouterHook();
  const getStartupUrl = useGetStartupUrl();

  return (
    <div>
      <NextHead
      title={'Listado de empresas Proptech | Proptechpedia'}
      description={'Encuentra por nombre o por categoría la empresa Proptech que buscas.'}
      />
      <Header routerTo={routerTo} />
      <main>
        <Board getStartupUrl={getStartupUrl} routerTo={routerTo} />
      </main>
      <CookiesBanner />
      <Footer />
    </div>
  )
}
